import { Modal } from "@/components/Kit";
import { useAuth } from "@/context/AuthContext";
import IdCardTemplate from "@/components/print/IdCardTemplate";
import { useTemplates, Scaled, PrintButton } from "@/components/print/PrintKit";

export default function IdCard({ student, onClose }) {
  const { school } = useAuth();
  const { data: tpl } = useTemplates();
  if (!student) return null;
  return (
    <Modal open={!!student} onClose={onClose} title="Student ID Card · PVC 5.4 × 8.5 cm" testid="id-card-modal">
      <div className="flex justify-center rounded-xl bg-slate-200 p-4">
        <Scaled scale={1.6} width="5.4cm" height="8.5cm"><IdCardTemplate student={student} school={school} tpl={tpl} /></Scaled>
      </div>
      <PrintButton title={`ID Card ${student.admission_no}`} size="5.4cm 8.5cm" label="Print ID Card (PVC)" testid="print-id-card-btn">
        <IdCardTemplate student={student} school={school} tpl={tpl} />
      </PrintButton>
    </Modal>
  );
}
